import { SMAAEffect } from 'postprocessing';

import { wrapEffect } from './wrapEffect.js';

export const SMAA = wrapEffect(SMAAEffect);
